import { UserRole } from '@/types';

/** Platform operator (co-taskr staff) — not a customer org admin. */
export function isPlatformOperator(role?: string | null): boolean {
  return role === UserRole.SUPER_ADMIN;
}

export type PlatformAdminTab =
  | 'organizations'
  | 'consumption'
  | 'audit'
  | 'waitlist'
  | 'feedback'
  | 'catalog'
  | 'entitlements';

export const PLATFORM_ADMIN_TABS: { id: PlatformAdminTab; label: string }[] = [
  { id: 'organizations', label: 'Organizations' },
  { id: 'consumption', label: 'Consumption' },
  { id: 'audit', label: 'Platform audit' },
  { id: 'waitlist', label: 'Waitlist' },
  { id: 'feedback', label: 'Feedback' },
  { id: 'catalog', label: 'Catalog & pricing' },
  { id: 'entitlements', label: 'Products & entitlements' },
];

export function platformAdminPath(tab: PlatformAdminTab): string {
  if (tab === 'organizations') return '/admin';
  return `/admin?tab=${tab}`;
}

export function parsePlatformAdminTab(search: string): PlatformAdminTab {
  const raw = new URLSearchParams(search).get('tab');
  if (raw === 'tiers') return 'catalog';
  const allowed = new Set(PLATFORM_ADMIN_TABS.map((t) => t.id));
  if (raw && allowed.has(raw as PlatformAdminTab)) return raw as PlatformAdminTab;
  return 'organizations';
}
